import { truncateDecimals } from "./numberFormatter";

export const formatNumber = (number: number) => {
  if (!number) {
    return "0";
  }
  if (number % 1 === 0) {
    return truncateDecimals(number, 0);
  } else {
    const formatted = truncateDecimals(number, 2);
    let result = formatted.replace(/0+$/, "");
    if (result.endsWith(".")) {
      result = result.slice(0, -1);
    }
    return result || "0";
  }
};

export const formatAmount = (amount: number, assetSymbol?: string): string => {
  if (!amount && amount !== 0) return "0.00";
  const symbolUpper = assetSymbol?.toUpperCase();
  const decimalPlaces =
    symbolUpper === "BTC" || symbolUpper === "BITCOIN" ? 6 : 2;
  return truncateDecimals(amount, decimalPlaces);
};
export const formatCurrency = (amount: number, currency: string) => {
  return (
    currency +
    " " +
    (typeof amount === "number"
      ? formatNumberObj({ value: formatNumber(amount) })
      : amount)
  );
};

export const formatNumberObj = ({
  value,
  format = true,
}: {
  value: string;
  format?: boolean;
}) => {
  const v = value.replace(/[- #*;,<>{}[\]\\/]/gi, "");
  if (format) {
    return v.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ");
  }
  try {
    return Number(v);
  } catch (error) {
    return null;
  }
};
export function formatNumberkMM(num: number) {
  if (num >= 1_000_000) {
    return truncateDecimals(num / 1_000_000, 1).replace(/\.0$/, "") + "M";
  } else if (num >= 1_000) {
    return truncateDecimals(num / 1_000, 1).replace(/\.0$/, "") + "k";
  } else {
    return num.toString();
  }
}

export const formatNumberWithCommas = (value: string | number): string => {
  if (!value && value !== 0) return "";
  const numString = value.toString().replace(/,/g, "");

  if (isNaN(Number(numString))) return "";

  return Number(numString).toLocaleString().replace(/,/g, " ");
};

export const parseFormattedNumber = (value: string): string => {
  if (!value) return "";
  return value.replace(/,/g, "").split(".")[0];
};
